import gql from 'graphql-tag';

export const mutationViewConversation = gql`
  mutation viewConversation (
    $id: DokkioID!
  ) {
    viewConversation (
      id: $id
    )
  }
`;
export default mutationViewConversation;
